import React from "react";
import { green, lime, orange, red, grey, yellow } from "@material-ui/core/colors";
import {
    BatteryFull,
    Battery80,
    Battery50,
    Battery30,
    Battery20,
    BatteryAlert,
    BatteryUnknown,
} from "@material-ui/icons";

export const TRACKER_BATTERY = {
    VERY_HIGH: "very_high",
    HIGH: "high",
    MEDIUM: "medium",
    LOW: "low",
    CRITICAL: "critical",
    EMPTY: "empty",
    UNKNOWN: "unknown"
};

const BATTERY_CONFIG = [
    {
        status: TRACKER_BATTERY.VERY_HIGH,
        min: 81,
        max: 100,
        Icon: BatteryFull,
        color: green[700]
    },
    {
        status: TRACKER_BATTERY.HIGH,
        min: 51,
        max: 80,
        Icon: Battery80,
        color: lime[700]
    },
    {
        status: TRACKER_BATTERY.MEDIUM,
        min: 31,
        max: 50,
        Icon: Battery50,
        color: yellow[500]
    },
    {
        status: TRACKER_BATTERY.LOW,
        min: 11,
        max: 30,
        Icon: Battery30,
        color: orange[600]
    },
    {
        status: TRACKER_BATTERY.CRITICAL,
        min: 2,
        max: 10,
        Icon: Battery20,
        color: red[600]
    },
    {
        status: TRACKER_BATTERY.EMPTY,
        min: 0,
        max: 1,
        Icon: BatteryAlert,
        color: red[600]
    }
];

export const getTrackerBatteryInfo = (level) => {

    if (level == null) {
        return {
            status: TRACKER_BATTERY.UNKNOWN,
            Icon: BatteryUnknown,
            color: grey[600],
            battery: null
        };
    }

    let battery = Math.round(level);
    battery = battery == 1 ? 0 : battery;

    const config = BATTERY_CONFIG.find(c =>
        battery >= c.min && battery <= c.max
    );

    if (!config) {
        return {
            status: TRACKER_BATTERY.UNKNOWN,
            Icon: BatteryUnknown,
            color: grey[600],
            battery
        };
    }

    return {
        ...config,
        battery
    };
};

export const getTrackerBatteryInfoByStatus = (status) => {

    if (status === TRACKER_BATTERY.UNKNOWN) {
        return {
            Icon: BatteryUnknown,
            color: grey[600]
        };
    }

    return BATTERY_CONFIG.find(c => c.status === status);
};